module.exports = __webpack_public_path__ + "img/pin-lidl.df7e3bfa.svg";